import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();

  return {
    root: (isActive = false) => {
      return {
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '20px',
        color: colors.white,
        py: 1,
        px: 2,
        backgroundColor: isActive ? appTheme.mainColor : '#0C0B0B66',
        borderRadius: 4,
        textTransform: 'none',
        '&:hover': {
          opacity: 1,
          backgroundColor: isActive ? appTheme.mainColor : '#0C0B0B',
        },
      };
    },
  };
};
